<template>
  <svg viewBox="0 0 600 600" :class="{ active: changeColor }">
    <rect
      x="297.95"
      y="-73.56"
      width="50.55"
      height="453.54"
      rx="15.81"
      ry="15.81"
      transform="translate(476.44 -170.01) rotate(90)"
    />
    <rect
      x="227.41"
      y="96.84"
      width="50.55"
      height="312.47"
      rx="15.88"
      ry="15.88"
      transform="translate(505.76 .38) rotate(90)"
    />
    <rect
      x="255.66"
      y="268.3"
      width="50.55"
      height="368.97"
      rx="15.69"
      ry="15.69"
      transform="translate(733.73 171.85) rotate(90)"
    />
    <rect
      x="173.84"
      y="250.27"
      width="50.55"
      height="205.32"
      rx="15.68"
      ry="15.68"
      transform="translate(552.05 153.81) rotate(90)"
    />
    <rect
      x="50"
      y="32"
      width="32.12"
      height="536"
      rx="14.36"
      ry="14.36"
      transform="translate(132.12 600) rotate(180)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    changeColor: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  rect {
    fill: $white;
  }
  &.active rect {
    fill: $white;
  }
}

.light svg {
  rect {
    fill: $gray-6;
  }

  &.active rect {
    fill: $white;
  }
}
</style>
